module.exports = __webpack_public_path__ + "img/info-circle.bd4bff9b.svg";